import React from "react";
import { Typography, Box } from "@mui/material";
import ScheduleFAQ from "@/assets/img/schedule-faq-ss.jpg";
import ModalWindow from "../ModalWindow";
import { useTranslation } from "react-i18next";

interface CancelModalProps {
  onActionButtonPress: () => Promise<void>;
  showModal: boolean;
  setShowModal: (close: boolean) => void;
}

const CancelModal: React.FC<CancelModalProps> = ({ onActionButtonPress, showModal, setShowModal }) => {
  const { t } = useTranslation("dashboard");
  return (
    <ModalWindow
      headerText={
        <Typography variant="h2">
          {t("dismissTutorialVideo")}
        </Typography>
      }
      showModal={showModal}
      setShowModal={setShowModal}
      actionButtonText={t("confirm", { ns: "common" })}
      actionButtonType="primary"
      onActionButtonPress={onActionButtonPress}
      renderBody={() => (
        <Box>
          <Typography variant="body2" mb={3}>
            {t("confirmDismissTutorialVideo")}
          </Typography>
          <Typography variant="body1" mb={2}>
            {t("youCanAlwaysViewThisLater")}
          </Typography>
          <img src={ScheduleFAQ} alt="Schedule FAQ" />
        </Box>
      )}
      cancelButtonText={t("cancel", { ns: "common" })}
      sx={{
        maxWidth: "350px",
        margin: "auto",
        "&.modal-container": {
          ".MuiDialogContent-root": {
            padding: "16px",
          },
          ".MuiDialogActions-root": {
            flexDirection: "row-reverse",
            justifyContent: "right",
          },
        },
      }}
    />
  );
};

export default CancelModal;
